import { render, staticRenderFns } from "./FilterOptionPos.vue?vue&type=template&id=062c36d6&scoped=true&"
import script from "./FilterOptionPos.vue?vue&type=script&lang=js&"
export * from "./FilterOptionPos.vue?vue&type=script&lang=js&"
import style0 from "./FilterOptionPos.vue?vue&type=style&index=0&id=062c36d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062c36d6",
  null
  
)

export default component.exports